import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "antd";
import Input from "comps/Input";
import { useDownLoadTransactionReport } from "hooks/useTransactions";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { DownLoadCSVSchema,   } from "validations";

type PayloadType = {
  from: string;
  to: string;
};


type PropType = {
	openModal:  {type: string},
	setModal: React.Dispatch<React.SetStateAction<{type: string}>>
};
   
export  const getYYYYMMDD = (date: Date | string) => new Date(date).toISOString().split("T")[0];



const DownloadReport: React.FC<PropType> = ({openModal, setModal}) => {
	const {handleDownloadTransactionReport, loading: loadingDownload} = useDownLoadTransactionReport();

	const { control, handleSubmit, formState: { errors }, reset } = useForm<PayloadType>({
		defaultValues: { from:    getYYYYMMDD(new Date(new Date().setDate(new Date().getDate() - 30))), to:  getYYYYMMDD(new Date())},
		resolver: yupResolver(DownLoadCSVSchema),
	});

	
	const onSubmit = async (data: PayloadType) => {
		const res =  await handleDownloadTransactionReport({from: getYYYYMMDD(data.from), to: getYYYYMMDD(data.to)})
		 if(res?.data){
			reset()
			setModal({type: ""});
		 }
	};


	return (
		<Modal
			open={openModal.type === "DOWLOAD_REPORT" }
			title={ "Download Transaction Report"}
			onCancel={() => {
				setModal({type: ""});
			}}
			okText={ "Download"}
			okButtonProps={{ htmlType: "submit" }}
			onOk={handleSubmit(onSubmit,  (e) => [])}
			confirmLoading={loadingDownload}
		>

		 
				<Controller
					control={control}
					name="from"
					render={({ field: { value, ...rest} }) => (
						<Input
							label="Start date"
							extraClass="mb-5"
							type="date"
							error={errors.from?.message}
							value={value  }
							{...rest}
							ref={null}
						/>
					)}
				/>
				<Controller
					control={control}
					name="to"
					render={({ field: { value, ...rest}  }) => (
						<Input
							label="End date"
							extraClass="mb-5"
							type="date"
							error={errors.from?.message}
							value={value   }
							{...rest}
							ref={null}
						/>
					)}
				/>
	 
		</Modal>
	);
};

export default DownloadReport;
